import React, { VFC } from 'react';
import AmbassadorComponent from '~/src/feature/Ambassador/components';
import { HeaderProps } from '~/src/feature/Ambassador/types';

type Props = HeaderProps & {
  authenticated: boolean;
};

const Ambassador: VFC<Props> = ({ authenticated, ...headerProps }) => {
  return (
    <AmbassadorComponent
      authenticated={authenticated}
      headerProps={headerProps}
    />
  );
};

export default Ambassador;
